import styled from 'styled-components';
import { Box } from '@edapp/ed-components';

export const StyledContainer = styled(Box)`
  max-height: 600px;
  width: 440px;
  overflow-y: auto;
`;
